export const ERROR_MESSAGE = 'Vui lòng thử lại sau';
